import { ThemeDefinition } from 'vuetify';

const files = import.meta.glob(['./*.ts', '!./index.ts']);

const subjectThemesPromise: Promise<Record<string, ThemeDefinition>> = Promise.all(
  Object.entries(files).map(async ([_path, importer]) => {
    const theme = (await importer()) as Record<string, ThemeDefinition>;
    return Object.entries(theme).reduce(
      (acc, [key, value]) => {
        acc[key] = value;
        return acc;
      },
      {} as Record<string, ThemeDefinition>,
    );
  }),
).then((results) =>
  results.reduce(
    (acc, module) => {
      if (module) {
        return { ...acc, ...module };
      }
      return acc;
    },
    {} as Record<string, ThemeDefinition>,
  ),
);

export default subjectThemesPromise;
